const names = {
  by_schedule: 'По расписанию',
  by_flight: 'Рейсом',
  asap: 'По готовности',
  departed: 'Вылетел',
  arrived: 'Прибыл',
  boarding: 'Посадка',
  checkinborading: 'Регистрация и посадка',
  registration: 'Регистрация',
  checkin: 'Регистрация',
  checkinclosed: 'Регистрация закрыта',
  complete: 'Рейс завершен',
  delay: 'Отложен',
  delayed: 'Задержан',
  cancel: 'Отменен',
  canceled: 'Отменен',
  cancelled: 'Отменен',
};

export default class TabloStatus {
  #item = null;

  successStatuses = ['checkinboarding', 'checkin'];

  staleStatuses = ['by_schedule'];

  errorStatuses = ['canceled', 'cancelled', 'delayed', 'delay', 'cancel'];

  processStatuses = ['arrived', 'departed', 'asap', 'estimated', 'by_flight'];

  warningStatuses = ['boarding', 'checkinclosed'];

  constructor(data) {
    this.#item = data;
  }

  get code() {
    const code = this.#item.replace(/\s+/g, '').replace(/-/g, '').toLowerCase();
    const status = /^by/.test(code) && code !== 'by_schedule' ? 'by_flight' : code;
    return status;
  }

  get name() {
    if (!this.code || this.code === '-') return '';
    const name = names[this.code];

    return this.code === 'by_flight' ? `${name} ${this.#item.replace('by_', '')}` : name;
  }

  get color() {
    if (this.successStatuses.includes(this.code)) return '#84B550';
    if (this.staleStatuses.includes(this.code)) return '#A9B2C6';
    if (this.errorStatuses.includes(this.code)) return '#D50000';
    if (this.warningStatuses.includes(this.code)) return '#ED8923';
    return '#1AA1ED';
  }

  get isError () {
    return this.errorStatuses.includes(this.code);
  }

  get icon() {
    switch (this.code) {
    case 'checkin':
    case 'checkinboarding':
      return 'checkin';
    case 'by_schedule':
      return 'schedule';
    case 'cancel':
    case 'canceled':
    case 'cancelled':
      return 'canceled';
    case 'delayed':
    case 'delay':
      return 'delayed';
    case 'arrived':
      return 'arrived';
    case 'departed':
      return 'departed';
    case 'asap':
    case 'estimated':
    case 'by_flight':
      return 'process';
    case 'boarding':
    case 'checkinclosed':
      return 'boarding';
    default:
      return 'process';
    }
  }
}